
<header class="top-panel">
  <div class="brand">
    <img src="assets/images/logo.png" class="logo" style="height: 80px;">
    <label class="title">Racketlon NZ</label>
  </div>
  <div class="tournament-name">{{ DataService?.SelectedTorn?.name }}</div>
  <nav class="nav">
    <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">home</a>
    <a routerLink="/tournaments" routerLinkActive="active">TOURNAMENTS</a>
    <a routerLink="/rankings" routerLinkActive="active">RANKINGS</a>
    <a routerLink="/gallery" routerLinkActive="active">gallery</a>
    <a routerLink="/rules" routerLinkActive="active">rules</a>
    <a routerLink="/links" routerLinkActive="active">links</a>
    <a href="mailto: racketlonnz@yahoo.com">CONTACT</a>
    @if (DataService.LoggedInUser.name == 'Login') {
      <a routerLink="/login" routerLinkActive="active">LOG IN</a>
    }
    @if (DataService.LoggedInUser.name != 'Login') {
      <a routerLink="/login" routerLinkActive="active">Profile</a>
    }
    <a href="Http://www.facebook.com/racketlonNZ/" target="_blank"><img src="assets/images/Facebook.png"  alt="Racketlon Facebook Page" class="logo" style="height: 30px; border-radius: 5px; padding: 0px"></a>
  </nav>
</header>
<main class="app-content">
  <router-outlet></router-outlet>
</main>
<!-- <app-side-bar #SideBar
(MainStatusEmit)="MainStatusEmit($event)"
(SelectGalleryFoldersIndexEmit)="SelectGalleryFoldersIndexEmit($event)"
></app-side-bar> -->

<!-- <app-gallery *ngIf="DataService.MainStatus == 'Gallery'"
[SelectedFolder]="SelectedFolder"
></app-gallery>
<app-player-history id="PlayerMatchHistory"  *ngIf="DataService.MainStatus == 'History'"></app-player-history>
<app-rankings *ngIf="DataService.MainStatus == 'Rankings'"></app-rankings>
<app-login *ngIf="DataService.MainStatus == 'Login' || DataService.MainStatus == 'NewUser' || DataService.MainStatus == 'UserMaintenance'"></app-login>
<app-home *ngIf="DataService.MainStatus == 'Home'"></app-home>-->
@if (AlertService.currentAlert || AlertService.currentDialog) {
  <Modal-Window
  [left]="100"
  [top]="400"
></Modal-Window>
}<!--
<app-videos *ngIf="DataService.MainStatus == 'Videos' && DataService.VideoFiles"></app-videos>
<app-database *ngIf="DataService.MainStatus == 'Database'"></app-database>
<app-torns *ngIf="DataService.MainStatus == 'Torns'" style="display: block;"></app-torns>
<app-rulz *ngIf="DataService.MainStatus == 'Rules'"></app-rulz>
<app-chart *ngIf="DataService.MainStatus == 'Chart'" style="    display: inline-block;"></app-chart> -->

